export default "__VITE_ASSET__Bdak5FlX__"